import { BrowserModule } from "@angular/platform-browser";
import { NgModule, provideZoneChangeDetection } from "@angular/core";
import { CommonModule, DatePipe } from '@angular/common';
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { HeaderComponent } from "./shared-module/components/header/header.component";
import { FooterComponent } from "./shared-module/components/footer/footer.component";
import { NgxPaginationModule } from "ngx-pagination";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { JwtInterceptor } from "../app/core-module/guards/jwtInterceptors";
import { ErrorInterceptor } from "../app/core-module/guards/errorHandler";
import { SelectingDeviceModalComponent } from "./shared-module/components/selecting-device-modal/selecting-device-modal.component";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { ConfigureDeviceModalComponent } from "./shared-module/components/configure-device-modal/configure-device-modal.component";
import { NgxSliderModule } from "@angular-slider/ngx-slider";
import { FormlyModule } from "@ngx-formly/core";
import { SliderComponent } from "./shared-module/components/slider/slider.component";
import { AloSliderComponent } from "./shared-module/components/alo-slider/alo-slider.component";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader, TRANSLATE_HTTP_LOADER_CONFIG } from "@ngx-translate/http-loader";
import { PsuFeatureComponent } from "./shared-module/components/psu-feature/psu-feature.component";
import { LumInfoComponent } from "./shared-module/components/lum-info/lum-info.component";
import { NgSelectModule } from '@ng-select/ng-select';
import { ZtvComponent } from "./shared-module/components/ztv/ztv.component";
import { StartuptimeComponent } from "./shared-module/components/startuptime/startuptime.component";

import { ReadDeviceComponent } from "./shared-module/components/read-device/read-device.component";
import { ReaderSelectionPopupComponent } from "./shared-module/components/reader-selection-popup/reader-selection-popup.component";
import { SupportedFeaturesComponent } from "./shared-module/components/supported-features/supported-features.component";
import { DtlComponent } from "./shared-module/components/dtl/dtl.component";
import { ReadDefaultValuesPopupComponent } from "./shared-module/components/read-default-values-popup/read-default-values-popup.component";
import { CorridorComponent } from "./shared-module/components/corridor/corridor.component";
import { CorridorGraphComponent } from "./shared-module/components/corridor-graph/corridor-graph.component";
import { DcemergencyComponent } from "./shared-module/components/dcemergency/dcemergency.component";
import { MinDimLevelComponent } from "./shared-module/components/min-dim-level/min-dim-level.component";
import { TouchDimComponent } from "./shared-module/components/touch-dim/touch-dim.component";
import { DtlGraphComponent } from "./shared-module/components/dtl-graph/dtl-graph.component";
import { DimmingInterfaceComponent } from "./shared-module/components/dimming-interface/dimming-interface.component";
import { ConverToNumberPipe } from "./shared-module/pipes/conver-to-number.pipe";
import { OnlynumberDirective } from "./shared-module/directive/onlynumber.directive";
import { MidnightShiftCalculationComponent } from "./midnight-shift-calculation/midnight-shift-calculation.component";
import { FeatureFilePartialCompatibleModalComponent } from "./feature-file-partial-compatible-modal/feature-file-partial-compatible-modal.component";
import { LineSwitchComponent } from "./shared-module/components/line-switch/line-switch.component";
import { ApmDimGraphComponent } from "./shared-module/components/apm-dim-graph/apm-dim-graph.component";
import { ApmDimComponent } from "./shared-module/components/apm-dim/apm-dim.component";
import { MtpComponent } from "./mtp/mtp.component";
import { MtpGraphComponent } from "./mtp-graph/mtp-graph.component";
import { ErrorComponent } from "./error/error.component";
import { CodedmainsComponent } from "./codedmains/codedmains.component";
import { DataLayerService } from "./core-module/services/data-layer.service";
import { WindowReferenceService } from "./core-module/services/window-reference.service";
import { NetworkConnectivityService } from "./core-module/services/network-connectivity.service";
import { ConfigureDeviceModalInputComponent } from "./configure-device-modal-input/configure-device-modal-input.component";
import { ConfigureDeviceModalInputErrorComponent } from "./configure-device-modal-input-error/configure-device-modal-input-error.component";
import { ConfigureDeviceModalInputErrorPositiveComponent } from "./configure-device-modal-input-error-positive/configure-device-modal-input-error-positive.component";
import { ReadDeviceMultiDriverComponent } from "./read-device-multi-driver/read-device-multi-driver.component";
import { ReadDeviceMultiDriverNextComponent } from "./read-device-multi-driver-next/read-device-multi-driver-next.component";
import { ReadDeviceMultiDriverSuccessComponent } from "./read-device-multi-driver-success/read-device-multi-driver-success.component";
import { ReadDeviceMultiDriverErrorComponent } from "./read-device-multi-driver-error/read-device-multi-driver-error.component";
import { MultiDriverConfigureBoxComponent } from "./shared-module/components/multi-driver-configure-box/multi-driver-configure-box.component";
import { OwpComponent } from "./shared-module/components/owp/owp.component";
import { SupportedFeaturesComponentMulti } from "./shared-module/components/supported-features-multi/supported-features.component-multi";
import { DaliMComponent } from "./shared-module/components/dali-m/dali-m.component";
import { ReadDeviceSelectionPopupComponent } from "./shared-module/components/read-device-selection-popup/read-device-selection-popup.component";
import { ZtvoutputComponent } from "./ztvoutput/ztvoutput.component";
import { RsoComponent } from "./rso/rso.component";
import { LipComponent } from './lip/lip.component';
import { OwpPasswordComponent } from "./owp-password/owp-password.component";
import { FlextuneComponent } from './shared-module/components/flextune/flextune.component';
import { MultiConfigModeComponent } from './shared-module/components/multi-config-mode/multi-config-mode.component';
import { appInputError } from "./shared-module/directive/app-input-error.directive";
import { OAuthModule } from "angular-oauth2-oidc";
import {DndDirectiveDirective} from "./shared-module/directive/dnd-directive.directive";
import { Dali102Component } from './shared-module/components/dali102/dali102.component';
import { Dali102and207Component } from './shared-module/components/dali102and207/dali102and207.component';
import { AuxoutputComponent } from './shared-module/components/auxoutput/auxoutput.component';
import { LsiComponent } from './shared-module/components/lsi/lsi.component';
import { AocMultichannelComponent } from './shared-module/components/aoc-multichannel/aoc-multichannel.component';
import { OtpComponent } from './shared-module/components/otp/otp.component';
import { DscComponent } from './shared-module/components/dsc/dsc.component';
import { OtpFtpGraphComponent } from './otp-ftp-graph/otp-ftp-graph.component';
import { OtpDtpGraphComponent } from './otp-dtp-graph/otp-dtp-graph.component';
import { FeatureConfigurationSharedModule } from "./shared-module/feature-configuration-shared.module";
import { LowMainsLockComponent } from './shared-module/components/lowmainslock/lowmainslock';
import { DipswitchComponent } from './shared-module/components/dipswitch/dipswitch';
export function HttpLoaderFactory() {
  return new TranslateHttpLoader();
}


@NgModule({
    declarations: [
        AppComponent,
        HeaderComponent,
        FooterComponent,
        SelectingDeviceModalComponent,
        ConfigureDeviceModalComponent,
        SliderComponent,
        AloSliderComponent,
        PsuFeatureComponent,
        LumInfoComponent,
        ZtvComponent,
        StartuptimeComponent,
        ReadDeviceComponent,
        ReaderSelectionPopupComponent,
        ReadDeviceSelectionPopupComponent,
        SupportedFeaturesComponent,
        SupportedFeaturesComponentMulti,
        DtlComponent,
        ReadDefaultValuesPopupComponent,
        CorridorComponent,
        CorridorGraphComponent,
        DcemergencyComponent,
        MinDimLevelComponent,
        TouchDimComponent,
        DtlGraphComponent,
        DimmingInterfaceComponent,
        ConverToNumberPipe,
        appInputError,
        DndDirectiveDirective,
        MidnightShiftCalculationComponent,
        FeatureFilePartialCompatibleModalComponent,
        LineSwitchComponent,
        ApmDimGraphComponent,
        ApmDimComponent,
        MtpComponent,
        MtpGraphComponent,
        ErrorComponent,
        OwpPasswordComponent,
        CodedmainsComponent,
        ConfigureDeviceModalInputComponent,
        ConfigureDeviceModalInputErrorComponent,
        ConfigureDeviceModalInputErrorPositiveComponent,
        ReadDeviceMultiDriverComponent,
        ReadDeviceMultiDriverNextComponent,
        ReadDeviceMultiDriverSuccessComponent,
        ReadDeviceMultiDriverErrorComponent,
        MultiDriverConfigureBoxComponent,
        OwpComponent,
        DaliMComponent,
        ReadDeviceSelectionPopupComponent,
        ZtvoutputComponent,
        FlextuneComponent,
        MultiConfigModeComponent,
        Dali102Component,
        Dali102and207Component,
        AuxoutputComponent,
        LsiComponent,
        OtpComponent,
        DscComponent,
        OtpFtpGraphComponent,
        OtpDtpGraphComponent,
        AocMultichannelComponent,
        LowMainsLockComponent,
        DipswitchComponent
    ],
    imports: [
        BrowserModule,
        CommonModule,
        AppRoutingModule,
        ReactiveFormsModule,
        FormsModule,
        NgxPaginationModule,
        NgbModule,
        NgxSliderModule,
        NgSelectModule,
        OnlynumberDirective,
        FeatureConfigurationSharedModule,
        OAuthModule.forRoot(),
        FormlyModule.forRoot({
            types: [
                { name: "slider", component: SliderComponent },
                { name: "object", component: AloSliderComponent },
                { name: "powerSupply", component: PsuFeatureComponent },
                { name: "lumInfo", component: LumInfoComponent },
                { name: "ztv", component: ZtvComponent },
                { name: "startuptime", component: StartuptimeComponent },
                { name: "dtl", component: DtlComponent },
                { name: "corridor", component: CorridorComponent },
                { name: "lineSwitch", component: LineSwitchComponent },
                { name: "mtp", component: MtpComponent },
                { name: "ampDim", component: ApmDimComponent },
                { name: "dcemergency", component: DcemergencyComponent },
                { name: "minDimLevel", component: MinDimLevelComponent },
                { name: "touchDim", component: TouchDimComponent },
                { name: "dimming", component: DimmingInterfaceComponent },
                { name: "codedmains", component: CodedmainsComponent },
                { name: "owp", component: OwpComponent },
                { name: "daliM", component: DaliMComponent },
                { name: "rso", component: RsoComponent },
                { name: "ztvoutput", component: ZtvoutputComponent },
                { name: "lip", component: LipComponent },
                { name: "flextune", component: FlextuneComponent },
                { name: "multiconfig", component: MultiConfigModeComponent },
                { name: "dali102", component: Dali102Component },
                { name: "dali102and207", component: Dali102and207Component },
                { name: "auxoutput", component: AuxoutputComponent },
                { name: "lsi", component: LsiComponent },
                { name: "aocMultiChannel", component: AocMultichannelComponent },
                { name: "otp", component: OtpComponent },
                { name: "dsc", component: DscComponent },
                { name: "lowmainslock", component: LowMainsLockComponent },
                { name: "dipswitch", component: DipswitchComponent }
            ],
            validationMessages: [
                { name: "required", message: "This field is required" },
            ],
        }),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
            },
        }),
    ],
    providers: [
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideHttpClient(withInterceptorsFromDi()),
        DataLayerService,
        WindowReferenceService,
        NetworkConnectivityService,
        DatePipe,
        { provide: TRANSLATE_HTTP_LOADER_CONFIG, useValue: { prefix: "/assets/i18n/", suffix: ".json" } },
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    ],
    bootstrap: [AppComponent]
})
export class AppModule {}
